import { createFileRoute, notFound } from "@tanstack/react-router";

import { checklistTemplateItemsQueries } from "@/api/resources/checklistTemplateItems/queries";
import { checklistTemplatesQueries } from "@/api/resources/checklistTemplates/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import ChecklistTemplatePage from "@/components/ChecklistTemplate/ChecklistTemplatePage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute(
  "/_auth/workspaces/$workspace_id/knowledge-hub/checklist-templates/$checklist_template_id/",
)({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.knowledge-hub-checklist-templates"),
        icon: <Icon.CHECKLIST_TEMPLATES />,
        path: "/workspaces/$workspace_id/knowledge-hub/checklist-templates",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id, checklist_template_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();

    const currentChecklistTemplate = await context.queryClient.ensureQueryData(
      checklistTemplatesQueries.byId(checklist_template_id),
    );
    if (!currentChecklistTemplate) throw notFound();

    await context.queryClient.ensureQueryData(
      checklistTemplateItemsQueries.listByChecklistTemplate(currentChecklistTemplate.id),
    );

    const breadcrumbs: BreadcrumbsContext[] = [
      { label: currentChecklistTemplate.title, icon: <Icon.CHECKLIST_TEMPLATE /> },
    ];
    context.breadcrumbs.splice(2, 1, ...breadcrumbs);
  },
  component: ChecklistTemplatePage,
});
